// Modal.jsx
import React, { useEffect } from "react";
import { FaPhone, FaEnvelope, FaTimes } from "react-icons/fa";
import "./Modal.css";

const Modal = ({ isOpen, onClose }) => {
  // Close modal when pressing Escape key
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.keyCode === 27) {
        onClose();
      }
    };
    window.addEventListener("keydown", handleEsc);
    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  // Don't render if modal is not open
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button
          className="modal-close"
          onClick={onClose}
          aria-label="Close modal"
        >
          <FaTimes />
        </button>
        <div className="modal-header">
          <h2>Contact Us for a Quote</h2>
          <p>Get in touch with our team to discuss your requirements</p>
        </div>
        <div className="modal-body">
          <div className="contact-method">
            <div className="contact-icon">
              <FaPhone />
            </div>
            <div className="contact-info">
              <h3>Call Us</h3>
              <p>+254 727 834 517</p>
            </div>
          </div>
          <div className="contact-method">
            <div className="contact-icon">
              <FaEnvelope />
            </div>
            <div className="contact-info">
              <h3>Email Us</h3>
              <p>Info@avvoka.co.ke</p>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <p>We typically respond within 24 hours</p>
        </div>
      </div>
    </div>
  );
};

export default Modal;
